module.exports = __webpack_public_path__ + "img/cb-logo-green.19488435.svg";